import styled from 'styled-components';
import Input from 'components/common/Input';

export const InputStyled = styled(Input)``;
